// extracted by mini-css-extract-plugin
module.exports = {"container":"TrustedBadge_container__gzVWq"};